import React from "react";

import { ProfitReport, ProfitReportItem } from "../../../../models";

import "./ProfitCard.scss";
import { formatCurrency } from "../../../../lib/formatCurrency";

export interface ProfitCardProps {
  report: ProfitReport;
}

export function ProfitCard(props: ProfitCardProps) {
  const { report } = props;

  const renderProfitReportItem = (
    item: ProfitReportItem,
    name: string
  ): React.ReactNode => {
    return (
      <div className="itemContainer">
        <div className="sectionContainer">
          <div className="sectionTitle">{name}</div>

          <div className="totalContainer">
            <div className="">Total</div>
            <div className="totalText">{formatCurrency(item.total)}</div>
          </div>
        </div>

        <div className="dataContainer">
          <div className="dataSectionContainer">
            <div className="">Count</div>
            <div className="">{item.count.toFixed(2)}</div>
          </div>

          <div className="verticalDivider" />

          <div className="dataSectionContainer">
            <div className="">Base price</div>
            <div className="">
              {item.basePrice > 0 ? formatCurrency(item.basePrice) : "--"}
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="profit-card-component">
      {renderProfitReportItem(report.deliveries, "Deliveries")}
      {renderProfitReportItem(report.schedules, "Fuel")}
      {renderProfitReportItem(report.pickups, "Pickups")}
      {renderProfitReportItem(report.workingHours, "Employee Hours")}

      <div className="totalContainer">
        <div className="totalText">Total</div>
        <div className="totalValue">{formatCurrency(report.total)}</div>
      </div>
    </div>
  );
}
